import type ItemContext from 'owa-mail-store/lib/store/schema/ItemContext';
import updateFolderCountsInStore from 'mini-mail-folder-store/lib/actions/updateFolderCountsInStore';

export default function deleteItemsStoreUpdateFolder(
    itemContexts: ItemContext[],
    parentFolderId: string
) {
    let totalUnreadDeleted = 0;
    for (const itemContext of itemContexts) {
        if (!itemContext.isRead) {
            totalUnreadDeleted++;
        }
    }

    updateFolderCountsInStore(
        -1 * totalUnreadDeleted /* unreadCount */,
        -1 * itemContexts.length /* totalCount */,
        parentFolderId /* folderId */,
        true /* isDeltaChange */
    );
}
